// import $ from 'jquery';
// import 'jquery.easing';
// import videojs from 'video.js'
// import "video.js/dist/video-js.css"
// import { Header } from './components/Header.js';
// import { Contact } from './components/Contact.js';
// // import { SearchBox } from './components/SearchBox.js';
// // import { Product } from './components/Product.js';
// // import { Blog } from './components/Blog.js';
// import Slide from './components/Slide.js';
// import Swiper from 'swiper';
// import { Autoplay, EffectCreative } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/effect-creative';
// import 'swiper/css/navigation';
import { mediaQuery, scrollTo } from './utils/functions.js';

// Import the necessary function for preloading images
//import { preloadImages } from './utils/utils.js';


// mediaQuery();
// const headerInstance = Header();
// Contact();

// Slide();

function requireAll(r){
  r.keys().forEach(r);
}

// const pageHeader = document.querySelector('.lp25-site-wrapper .page-header');
// const lastLookItem = document.querySelector('.lp25-site-wrapper .looks__item:last-child');
// let lastLookItemY = 0;
// const pageBody = document.querySelector('body');
const pageWrapper = document.querySelector('.lp25-page-wrapper');
// const heroSection = pageWrapper.querySelector('.hero-section');

let isVertical = false;
let windowHeight = window.innerHeight;

const resizeHandler = (e)=>{
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // get x position of the footer
  // lastLookItemY = lastLookItem.getBoundingClientRect().top + window.scrollY;
  window.dispatchEvent(new Event('scroll'));
  windowHeight = window.innerHeight;

  if(window.innerWidth < window.innerHeight){
    isVertical = true;
  } else {
    isVertical = false;
  }
}


window.addEventListener('load', resizeHandler);
window.addEventListener('resize', resizeHandler);


const timer = (func, delay)=>{
  setTimeout(()=>{
    func();
  }, delay);
}

const slides = document.querySelectorAll('.lp25-page-wrapper .slider .slide');
// clone each slide and append it to the slider
slides.forEach((slide)=>{
  const clone = slide.cloneNode(true);
  document.querySelector('.lp25-page-wrapper .slider .slider-wrapper').appendChild(clone);
});


// Swiper.use([Autoplay, EffectCreative]);

function applyFadeIn() {
  
  pageWrapper.classList.remove("loaded");




  timer(() => {
    pageWrapper.classList.add("loaded");

  }, 1100); // 少し遅延させて適用
  //pageBody.classList.add("lp25-lock");

  // timer(()=>{
  //   window.scrollTo(0, 0);
  // }, 1000);

  //timer(() => pageBody.classList.remove("lp25-lock"), 7000);
}

document.addEventListener("DOMContentLoaded", applyFadeIn);
window.addEventListener("load", applyFadeIn);
window.addEventListener("pageshow", function(event) {
  if (event.persisted) {
    applyFadeIn(); // キャッシュ復元時にも実行
  }
});

let st = window.scrollY;
window.addEventListener('scroll', ()=>{
  // st = window.scrollY;

  // const scrollAmount = windowHeight * 2;

  // if(st > scrollAmount){
  //   pageWrapper.classList.add('scrolled');
  // } else {
  //   pageWrapper.classList.remove('scrolled');
  // }


  // let pageHeaderY = Math.min(0, (lastLookItemY - (st)) * 0.3);

  // console.log(pageHeaderY)

  // if(lastLookItemY < st + window.innerHeight){
  //   pageHeader.style.transform = `${pageHeaderY}px`;
  // } else {
  //   pageHeader.style.transform = `${pageHeaderY}px`;
  // }

  // let scrollX = window.scrollX;
  //heroSection.style.transform = `translateX(-${scrollX}px)`;

});

// trigger scroll event
window.dispatchEvent(new Event('scroll'));

const openModalButtons = document.querySelectorAll('.open-modal-button');
const modalCloseButton = document.querySelector('.modal__close-button');
const modal = document.querySelector('.modal');
const modalInner = document.querySelector('.modal__inner');
const looks = document.querySelectorAll('.look');



openModalButtons.forEach((button)=>{
  button.addEventListener('click', ()=>{
    modal.classList.add('active');
    const target = button.dataset.id ? button.dataset.id - 1 : 0;


    
    // get offset top of the target element
    const targetTop = target == 0 ? 0 : looks[target].offsetTop - 30;

    scrollTo({to: targetTop, element: modalInner, duration: 800});

  });
}
);

modalCloseButton.addEventListener('click', ()=>{
  modal.classList.remove('active');
});

const allSlides = document.querySelectorAll('.lp25-page-wrapper .slider .slide');
document.addEventListener("DOMContentLoaded", () => {
  const prlxElems = document.querySelectorAll(".stack__image, .slider, .credit__image, .prlx");

  let count = 0;
  const scrollHandler = () => {
    count = 0;
    prlxElems.forEach((prlxElem) => {

      const rect = prlxElem.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const st = window.scrollY;

      if(prlxElem.classList.contains("slider") && !prlxElem.classList.contains("executed")){

        if(rect.top < (windowHeight * 0.8)){
          prlxElem.classList.add("executed");
          allSlides.forEach((slide, index)=>{
            timer(() => {
              slide.querySelector('picture').classList.add('executed');
            }
            , 100 * index);
          });
        }

      } else if (prlxElem.classList.contains("stack__image") || prlxElem.classList.contains("credit__image")) {

        if (prlxElem.classList.contains("executed")) {
          return;
        }

        const distance = -((rect.top + st) - (st + windowHeight));

        // if image is first element in the stack

        let ratio = distance / windowHeight;

        // 左上から右下に向かって表示されるマスク
        if(ratio > 0){

          let ratio = isVertical == true ? (distance * 1.5) / windowHeight : (distance * 1.3) / windowHeight;


          const sizeX = Math.min(102, ratio * 100);
          const sizeY = Math.min(102, ratio * 100);
          //console.log(ratio * 0.01);
          const opacity = Math.min(1, 1 * ratio);

          prlxElem.querySelector("picture").style.clipPath = `polygon(0% 0%, ${sizeX}% 0%, ${sizeX}% ${sizeY}%, 0% ${sizeY}%)`;
          //prlxElem.querySelector("img").style.opacity = opacity;
          if(sizeX >= 100){
            //prlxElem.classList.add("executed");
            if(prlxElem.closest(".stack")){
              prlxElem.closest(".stack").classList.add("complete");
            }
          }

          if(sizeX < 50){
            //prlxElem.classList.add("executed");
            if(prlxElem.closest(".stack")){
              prlxElem.closest(".stack").classList.remove("complete");
            }
          }
        }

      } else {
        if(rect.top < (windowHeight * 0.8)){          
          if(prlxElem.classList.contains("qued")){
            return;
          }
          timer(() => {
            prlxElem.classList.add("executed");
          }, 100 * count);
          prlxElem.classList.add("qued");
          count++;
        }
      }
    });
  };

  window.addEventListener("scroll", scrollHandler);
  scrollHandler(); // 初回実行
});






